// src/telehealth/useConversationMessages.js
import { useEffect, useState } from "react";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { db } from "../../firebase";

export function useConversationMessages(conversationId) {
  const [messages, setMessages] = useState([]);
  const [loadingMessages, setLoadingMessages] = useState(false);

  useEffect(() => {
    if (!conversationId) return;
    setLoadingMessages(true);

    const messagesRef = collection(db, "conversations", conversationId, "messages");
    const q = query(messagesRef, orderBy("createdAt", "asc"));

    const unsub = onSnapshot(q, (snap) => {
      const data = [];
      snap.forEach((docSnap) => {
        data.push({ id: docSnap.id, ...docSnap.data() });
      });
      setMessages(data);
      setLoadingMessages(false);
    });

    return () => unsub();
  }, [conversationId]);

  return { messages, loadingMessages };
}
